<template>
  <div class="row px-5 getting_started__row">
    <div class="content_row">
      <h3 class="getting_started__h3">Create an Ethereum Account</h3>

      <p class="getting_started__p">
        Accounts play a central role in Ethereum. There are two types of
        accounts: externally owned accounts (EOAs) and contract accounts. Here
        we focus on externally owned accounts, which will be referred to simply
        as accounts.
      </p>

      <p class="getting_started__p">
        Accounts represent identities of external agents (e.g., human personas,
        mining nodes or automated agents)
      </p>

      <p class="getting_started__p">
        Accounts are essential for users to interact with the Ethereum
        blockchain via transactions. click
        <a class="getting_started__a" @click="$router.push('/account-register')"
          >here</a
        >
        to create an ethereum account.
      </p>
    </div>

    <div class="content_row">
      <h3 class="getting_started__h3">Visit an Ethereum Testnet Faucet</h3>

      <p class="getting_started__p">
        Faucets are accounts on the test network that have been mining
        continuously / has been allocated with a large amount of ether.
      </p>

      <p class="getting_started__p">
        It's called a faucet as it drips ether after a specified amount of time
        passes. (Ropsten faucet drips 1 ether every 5 seconds), accounts can
        request test ether from faucets.
      </p>

      <p class="getting_started__p">
        Some faucets limit the amount of requests an account can make per day,
        faucets will often whitelist an account if it exceeds the amount of
        requests set.
      </p>

      <p class="getting_started__p">
        Ether is known as the fuel for operating in the Ethereum platform.
        Ether, like other digital currencies, can be used to pay for goods and
        services.
      </p>

      <ul>
        <li>
          <a
            class="getting_started__a_secondary"
            @click="redirect('https://faucet.ropsten.be/')"
            >https://faucet.ropsten.be/</a
          >
        </li>
        <li>
          <a
            class="getting_started__a_secondary"
            @click="redirect('https://faucet.metamask.io/')"
            >https://faucet.metamask.io/</a
          >
        </li>
      </ul>
    </div>

    <div class="content_row">
      <h3 class="getting_started__h3">Register as a Participant</h3>

      <p class="getting_started__p">
        There are multiple roles in the supply chain ecosystem, namely,
        manufacturers, suppliers, retailers, consumers, etc..
      </p>

      <p class="getting_started__p">
        To register as any of the following roles, click
        <a class="getting_started__a" @click="$router.push('/participant')"
          >here</a
        >
        or you can also click the register tab on the left side drawer.
      </p>

      <p class="getting_started__p">
        You will be prompted to enter your private key, and a passphrase to come
        along with it, the passphrase will be used to encrypt your private key,
        it will also be used for decrypting it.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirect: function(path) {
      window.open(path, '_blank')
    }
  }
}
</script>

<style scoped>
* {
}

.getting_started__row {
  max-width: 800px;
  /* word-wrap: break-word; */
}

.content_row {
  margin-bottom: 32px;
}

.getting_started__h1,
.getting_started__h2,
.getting_started__h3,
.getting_started__h4,
.getting_started__h5,
.getting_started__h6 {
  padding-bottom: 0.7em;
  border-bottom: 1px solid #ddd;
  width: 100%;
}

.getting_started__p {
  margin: 0.6rem 0;
  word-spacing: 0.05em;
  line-height: 1.6em;
}

.getting_started__row a.getting_started__a {
  cursor: pointer;
  color: rgb(41, 41, 248);
  text-decoration: underline;
}

ul {
  list-style: '-';
}

ul li {
  margin: 10px 0;
  max-width: max-content;
  padding: 0 0 0 15px;
}

ul li a.getting_started__a_secondary,
ul li a.getting_started__a_secondary:hover {
  text-decoration: underline;
}
</style>
